import { Button, ButtonProps } from 'antd';
import React from 'react';
import { useTheme } from 'src/styles/theme';

import classes from './style/AppPrimaryButton.module.css';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IAppPrimaryButtonProps {
  children?: React.ReactNode;
  className?: string;
}

const AppPrimaryButton: React.FunctionComponent<
  IAppPrimaryButtonProps & ButtonProps
> = (props) => {
  // TOOLS
  const theme = useTheme();
  // PROPS
  const { children, className, ...restProps } = props;

  // STATE

  // SELECTORS

  // VIEW
  return (
    <Button
      type="primary"
      {...restProps}
      className={`${classes.button} ${theme.fonts.classNames.button} ${className}`}
    >
      {children}
    </Button>
  );
};

export default AppPrimaryButton;
